import { LANDING_CPM_NIS } from '../config/pricingFactors';

/** Matches Linkly redirect for https://linkly.link/2W3Uk (update if link target changes). */
const DEFAULT_LANDING_WA_PHONE = '972545309673';

/**
 * @param {function(string): string} t - getTranslation(language, 'landing', key)
 * @param {{ cpm?: number, preamble?: string }} [options]
 */
export function buildLandingCtaWhatsAppUrl(t, options = {}) {
  const rawPhone =
    process.env.REACT_APP_LANDING_WHATSAPP_PHONE || DEFAULT_LANDING_WA_PHONE;
  const phone = String(rawPhone).replace(/\D/g, '');
  const cpm = options.cpm ?? LANDING_CPM_NIS;
  const cpmLine = t('ctaWhatsAppCpmLine').replace(/\{cpm\}/g, String(cpm));
  const parts = [options.preamble || t('ctaWhatsAppBase'), '', cpmLine];
  const text = parts.filter(Boolean).join('\n');
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}
